let fb_widget = $('.fb_widget');
if ($('#other_info_school').children().length === 0) $('#other_info').hide();
if ($('#social_icons').children().length === 1) $('.heading_connect_school').hide();
if (fb_widget.children().length === 0) fb_widget.addClass('height_unset');
if ($('#travel-info').children().length === 0) $('#travel-block').hide();

$(document).ready(function () {
    generateEA();
    if (typeof (hj) !== 'undefined' && hj) hj('vpv', '/school/details'); //HotJar

    $('.navigation').on('click', function () {
        let schoolid = $(this).attr("data-id");
        $.ajax({
            url: HOST + '/include/ajax_click.php',
            data: {
                schoolid: schoolid,
                type: 'navigation',
                schoolType: schoolType
            },
            error: function () {
//$('#schoollist').html('<p>An error has occurred</p>');
            },
            success: function (html) {
//console.log(html);
            },
            type: 'POST'
        });
    });

    $('.ga-click').on('click', function () {
        let schoolid = $(this).attr("data-id");
        $.ajax({
            url: HOST + '/include/ajax_click.php',
            data: {
                schoolid: schoolid,
                type: 'call',
                schoolType: schoolType
            },
            error: function () {
//$('#schoollist').html('<p>An error has occurred</p>');
            },
            success: function (html) {
//console.log(html);
            },
            type: 'POST'
        });
    });

    $('.website').on('click', function () {
        let schoolid = $(this).attr("data-id");
        $.ajax({
            url: HOST + '/include/ajax_click.php',
            data: {
                schoolid: schoolid,
                type: 'website',
                schoolType: schoolType
            },
            error: function () {
//$('#schoollist').html('<p>An error has occurred</p>');
            },
            success: function (html) {
//console.log(html);
            },
            type: 'POST'
        });
    });

    $('.email').on('click', function () {
        let schoolid = $(this).attr("data-id");
        $.ajax({
            url: HOST + '/include/ajax_click.php',
            data: {
                schoolid: schoolid,
                type: 'email',
                schoolType: schoolType
            },
            error: function () {
//$('#schoollist').html('<p>An error has occurred</p>');
            },
            success: function (html) {
//console.log(html);
            },
            type: 'POST'
        });
    });

    $('.phone').on('click', function () {
        let schoolid = $(this).attr("data-id");
        $.ajax({
            url: HOST + '/include/ajax_click.php',
            data: {
                schoolid: schoolid,
                type: 'phone',
                schoolType: schoolType
            },
            error: function () {
//$('#schoollist').html('<p>An error has occurred</p>');
            },
            success: function (html) {
//console.log(html);
            },
            type: 'POST'
        });
    });

    $('.feetab').on('click', function () {
        let schoolid = $(this).attr("data-id");
        $.ajax({
            url: HOST + '/include/ajax_click.php',
            data: {
                schoolid: schoolid,
                type: 'feetab',
                schoolType: schoolType
            },
            error: function () {
//$('#schoollist').html('<p>An error has occurred</p>');
            },
            success: function (html) {
//console.log(html);
            },
            type: 'POST'
        });
    });

    $('.admissiontab').on('click', function () {
        let schoolid = $(this).attr("data-id");
        $.ajax({
            url: HOST + '/include/ajax_click.php',
            data: {
                schoolid: schoolid,
                type: 'admissiontab',
                schoolType: schoolType
            },
            error: function () {
//$('#schoollist').html('<p>An error has occurred</p>');
            },
            success: function (html) {
//console.log(html);
            },
            type: 'POST'
        });
    });

    $('.admission_link').on('click', function () {
        let schoolid = $(this).attr("data-id");
        $.ajax({
            url: HOST + '/include/ajax_click.php',
            data: {
                schoolid: schoolid,
                type: 'admissionlink',
                schoolType: schoolType
            },
            error: function () {
//$('#schoollist').html('<p>An error has occurred</p>');
            },
            success: function (html) {
//console.log(html);
            },
            type: 'POST'
        });
    });

    $('.reviewstab').on('click', function () {
        let schoolid = $(this).attr("data-id");
        $.ajax({
            url: HOST + '/include/ajax_click.php',
            data: {
                schoolid: schoolid,
                type: 'reviewstab',
                schoolType: schoolType
            },
            error: function () {
//$('#schoollist').html('<p>An error has occurred</p>');
            },
            success: function (html) {
//console.log(html);
            },
            type: 'POST'
        });
    });

    $('.sch_social').on('click', function () {
        let schoolid = $(this).attr("data-id");
        $.ajax({
            url: HOST + '/include/ajax_click.php',
            data: {
                schoolid: schoolid,
                type: 'sch_social',
                schoolType: schoolType
            },
            error: function () {
//$('#schoollist').html('<p>An error has occurred</p>');
            },
            success: function (html) {
//console.log(html);
            },
            type: 'POST'
        });
    });
});

// Shortlist Button Clicked Analytics

function generateEA() {
    let puCheck = false;
    if(location.search.includes('pu=true')){
        puCheck=true;
    }
    let params = {};
    if (puCheck) {
        params = {
            school_url: schoolUrl,
            school_type: "5",
            school_type_2: schoolType,
        };
    } else {
        params = {
            school_url: schoolUrl,
            school_type: schoolType
        };
    }
    $.post(HOST + "/common/routes/ajax_init_school_view.php", params, function (response) {
        if(DEBUG) console.log("success", response);
        if (pageType && pageType === 'DETAILS-PAGE' && typeof updateEventUserId !== 'undefined') updateEventUserId();
    }).fail(function (error) {
        if(DEBUG) console.log("error", error);
        if (pageType && pageType === 'DETAILS-PAGE' && typeof updateEventUserId !== 'undefined') updateEventUserId();
    });
}

$(document).ready(function () {
    $('a.ed-score-popover[data-toggle="popover"]').popover({
        html: true,
        content: function () {
            return $('#popover-content-ed-admin').html();
        }
    });
    $('a.review-popover[data-toggle="popover"]').popover({
        html: true,
        content: function () {
            return $('#popover-content').html();
        }
    });
    checkAdmissionAppliedForSchool();
});


function checkAdmissionAppliedForSchool(){
    if(!user) return ;

    $.ajax({
        type: "GET",
        url: HOST + '/schools/Residential/server/check-admission-applied-for-school.php',
        data: {school_id: schoolId},
        success: function (data) {
            let res = JSON.parse(data);
            if (res.success == true) {
                $('#admissionBtnOnline').addClass('disabled');
                $('#admissionBtnOnline').parent().attr('target','');
                $('#admissionBtnOnline').parent().attr('href','#');
                $('#admissionBtnOnline').find('span').text('Registation Applied');
            }
        }, error: function (data) {
            if(DEBUG) console.log(data);
        }
    })

}

function getInTouchWithSchool(school_id) {
		showToast('info', 'Waiting', 'Please wait...');
		$.post(`${HOST}/common/routes/ajax_assistant_ready_to_walkin_school.php`, {school_id})
				.done(res => {
						let data = res && "data" in res && res.data ? res.data : {};
						let status = data && "status" in data && data.status && parseInt(data.status) ? parseInt(data.status) : 0;
						if (status) {
								showToast('success', 'Thanks.', 'School will get in touch with you.');
								$('div[data-v-type="ready-for-walkin"]').html(
										`<i class="fa fa-paper-plane" aria-hidden="true"></i>
										<span class="sch-vst-mob">Already Contacted</span>
										<span class="sch-vst-desk">Already Contacted</span>`
								);
								$('div[data-v-type="ready-for-walkin"]').removeAttr('onclick');
						} else {
								showToast('danger', 'Sorry', 'Try again or leave a query to us.');
						}
				})
				.fail(err => DEBUG?console.log({err}):1);
}
